import React from 'react';
import moment from 'moment';
import { PrimaryButton } from 'components/buttons/Button';
import EventInfoLine, { TYPE_EVENT_INFO_LINE_LOCATION, TYPE_EVENT_INFO_LINE_DATE } from 'components/EventInfo';
import useDefferedLink from './useDefferedLink';
import { useTranslation } from 'react-i18next';
import Logotype from 'components/Logotype';
import FORMAT from 'config/date/format';
import './style.scss';

export default ({ item, pid }) => {
    const [t] = useTranslation(['common', 'home']);

    const id = item.id || null;
    const event_url = useDefferedLink({event: item, pid}); 
    if (!+id) { //Broken item
        return <p>Error in data</p>;
    }

    const media = item.medium;

    const onClick = () => event_url && window.open(event_url, '_blank');

    return (
    <div className='zt-card'>
        <div className='zt-card__imageholder' {...{onClick}}>
            {media ?
            <img alt={item.name} className='zt-card__imageholder__image' src={`${media}${"?width=620&height=480"}`} />
            :
            <Logotype className='zt-card__imageholder__logotype'/>
            }
        </div>
        <div className='d-flex flex-column zt-card__body'>
            <div className='card-title'>
            <h4><a target="_blank" href={event_url || '#'}>{item.name}</a></h4>
            </div>
            <div className='zt-card__description zt-p1'>{item.performer_name}</div>
            <EventInfoLine type={TYPE_EVENT_INFO_LINE_LOCATION} card>{item?.map?.venue.name}</EventInfoLine>
            <EventInfoLine type={TYPE_EVENT_INFO_LINE_DATE} card>{t('home:eventslist.card.date', {date: moment(item?.start_date, FORMAT)})}</EventInfoLine>
            <PrimaryButton {...{onClick}}>{t('buttons.buy', 'Buy Tickets')}</PrimaryButton>
        </div>
    </div>);
}